<template>
  <div class="container">
    <div class="login">
      <div class="login-box">
        <div class="logo">
          <div class="logo-inner">
            <div class="logo-part part1"></div>
            <div class="logo-part part2"></div>
            <div class="logo-part part3"></div>
            <div class="logo-part part4"></div>
          </div>
        </div>
        <div class="body">
          <p class="tips">豪超五金管理系统</p>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="" prop="username">
              <el-input v-model="form.username" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input
                  type="password"
                  v-model="form.password"
                  placeholder="密码"
                  @keyup.enter.native="startLogin"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                  type="primary"
                  @click="startLogin"
                  :loading="loading"
                  style="width: 100%"
              >
                {{ loading ? "登录中..." : "登录" }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="beian">
      备案：<a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备2024053660号-1</a>
    </div>
  </div>
</template>

<script>
import api from "@/config/api";
export default {
  data() {
    return {
      root: "",
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码不得低于6个字符", trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  components: {},
  methods: {
    startLogin() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        let root = this.root;
        this.axios
            .post(root + "auth/login", {
              username: this.form.username,
              password: this.form.password,
            })
            .then((res) => {
              let call = res.data;
              this.loading = false;
              if (res.data.errno === 0) {
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.data.data.userInfo)
                );
                document.querySelector(".container").style.animation = "none"; // 停止动画
                this.$router.push({ name: "order" });
                let sUserAgent = navigator.userAgent;
                let mobileAgents = [
                  "Android",
                  "iPhone",
                  "Symbian",
                  "WindowsPhone",
                  "iPod",
                  "BlackBerry",
                  "Windows CE",
                ];
                let goUrl = 0;
                for (var i = 0; i < mobileAgents.length; i++) {
                  if (sUserAgent.indexOf(mobileAgents[i]) > -1) {
                    goUrl = 1;
                    break;
                  }
                }
                if (goUrl == 1) {
                  this.$router.push({ name: "wap" });
                }
              } else {
                this.$message({
                  type: "error",
                  message: call.errmsg,
                });
                return false;
              }
            })
            .catch((err) => {
              this.loading = false;
            });
      });
    },
  },
  mounted() {
    this.root = api.rootUrl;
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 50, 0.8), rgba(0, 50, 100, 0.8)),
  url("../../public/static/images/background.webp") no-repeat center center fixed;
  background-size: cover;
  animation: gradient 15s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.login-box {
  width: 350px;
  padding: 40px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
  width: 60px;
  height: 60px;
  position: relative;
}

.logo-inner {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 50%;
  background: radial-gradient(circle at center, #0077b6, #00aaff, #48cae4, #90e0ef);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: logoRotate 10s linear infinite;
}

.logo-part {
  width: 50%;
  height: 50%;
}

.part1 {
  background: rgba(0, 119, 182, 0.7);
}

.part2 {
  background: rgba(0, 170, 255, 0.7);
}

.part3 {
  background: rgba(72, 202, 228, 0.7);
}

.part4 {
  background: rgba(144, 224, 239, 0.7);
}

@keyframes logoRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.body {
  text-align: center;
}

.body .tips {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.el-input__inner {
  border-radius: 5px;
  padding: 10px;
}

.el-button {
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
}

.beian {
  background-color: rgba(255, 255, 255, 0.7);
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: black;
  padding: 10px 0;
}
.beian a {
  color: black;
  text-decoration: none;
}
.beian a:hover {
  text-decoration: underline;
}
</style>
